'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeSelectors = undefined;

var _reselect = require('reselect');

var _helpers = require('./helpers'); // Barebone selectors for barebone reducer


var makeSelectors = exports.makeSelectors = function makeSelectors(stateSelector) {
  var getBaseState = function getBaseState(state) {
    return (0, _helpers.getOrSelect)(state, stateSelector);
  };

  var getData = (0, _reselect.createSelector)(getBaseState, function (_ref) {
    var data = _ref.data;
    return data;
  });
  var isLoading = (0, _reselect.createSelector)(getBaseState, function (_ref2) {
    var loading = _ref2.loading;
    return loading;
  });
  var getError = (0, _reselect.createSelector)(getBaseState, function (_ref3) {
    var error = _ref3.error;
    return error;
  });
  return {
    getBaseState: getBaseState,
    getData: getData,
    isLoading: isLoading,
    getError: getError
  };
};